import { render, staticRenderFns } from "./BrandDropdown.vue?vue&type=template&id=2dbb6338&"
import script from "./BrandDropdown.vue?vue&type=script&lang=js&"
export * from "./BrandDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports